import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "../../../../styles/Payments/SuccessPrePay.module.scss";
import { Link } from "react-router";
import Globals, { URLS } from "../../../../utility/constants/appConstants";
import { useSelector } from "react-redux";
import InvoicesPopUp from '../../../ui/InvoicesPopUp';

const SuccessPrepay = (props) => {
  
  const {labels, successProps, oneTime} = props;
  const customerSummary = useSelector((state) => state.login.customerInfo);
  const [popupData, setPopupData] = useState({});
  const [invoiceNum, setInvoiceNum] = useState("");
  const donation = 0;
  
  // Replace {EMAIL} placeholder in successNote
  if (typeof labels.successNote === "string") {
    labels.successNote = labels.successNote.replace(
      "{EMAIL}", customerSummary?.[0]?.EmailAddress || ""
    );
  }
  
  const modalRef = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);

  const handlePrint = (e) => {
    e.preventDefault();
    if (typeof window !== "undefined") {
      window.print();
    }
  };

  const handlePopUp = (e, salesAgrNum) => {
    e.preventDefault();
    const invoiceNumber = e.target.getAttribute("invoicenum");
    const selectedInvoiceData = successProps.salesAgreements.data[salesAgrNum];
    setInvoiceNum(invoiceNumber);
    setPopupData(selectedInvoiceData);
    if (modalRef.current) {
      window.$(modalRef.current).modal("show");
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    if (modalRef.current) {
      window.$(modalRef.current).modal("hide");
    }
  };

  let finalAmtBeforeDon = 0;
  let finalAmtBeforeDonFormatted;
  let discount = 0;
  let discountFormatted;
  let finalAmt = 0;
  let finalAmtFormatted;

  return (
    <div className={styles.wrapper}>
      <div className={styles.summary}>
        <div
          className={styles.paymentReceived}
          dangerouslySetInnerHTML={{ __html: labels.paymentReceived }}
        />
        <img
          src="/images/check-circle-solid.svg"
          alt="Success"
          className={styles.successIcon}
        />
        {/*Prepay block */}
        {!oneTime && <div className={`gfs-16 gfs-lg-28 gfw-3 glh-1_1 mb-30 text-dark ${styles['prepayment-num']}`}>
            <span dangerouslySetInnerHTML={{ __html: labels.successMsgPP }} />{successProps?.confNum}
            <span />
          </div>}
        {oneTime && <div className={`gfs-16 ${styles['gfs-lg-28']} gfw-3 glh-1_1 mb-30 text-dark`}>
                {labels.successMsgOT}<br />{successProps?.confNum}
              </div>}
        {!oneTime && successProps?.salesAgreements?.value.map((salesAgrNum, i) => {  
           const prepay = successProps.salesAgreements.data[salesAgrNum].PrePay[0];
          const totalAmt = prepay.yiaTotalAmt.toString().split('.');
          finalAmtBeforeDon = finalAmtBeforeDon + prepay.yiaTotalAmt;
          discount = discount + prepay.yiaDiscAmt;
          return (
            <div key={`success-${i}`} className={styles.serviceRow}>
              <div className={styles.serviceDesc}>{successProps.salesAgreements.data[salesAgrNum].svcLineDesc}</div>
              <div className={styles.amountBox}>
                <span>{labels.amtPrepaid}</span>
                <span className={styles.amount}>
                  {Globals.currencySymbol}
                  {totalAmt[0]}
                  <sup>{totalAmt[1] ? (totalAmt[1].length < 2 ? totalAmt[1] + '0' : totalAmt[1].substring(0, 2)) : '00'}</sup>
                </span>
              </div>
            </div>
          );
        }
        )}
        {oneTime && successProps?.salesAgreements?.value.map((salesAgrNum, i) => {
          const invoiceBalance = successProps.salesAgreements.data[salesAgrNum].invoice.invoiceBalance.toString().split('.');
          const invAmtIntPart = invoiceBalance[0];
          const invAmtFractPart = invoiceBalance[1] ? (invoiceBalance[1].length < 2 ? invoiceBalance[1] + '0' : invoiceBalance[1].substring(0, 2)) : '00';
          finalAmtBeforeDon = finalAmtBeforeDon + successProps.salesAgreements.data[salesAgrNum].invoice.invoiceBalance;
          
          return (
            <div key={`success-${i}`} className={styles.serviceRow}>
              <div className={styles.serviceDesc}>
                {successProps.salesAgreements.data[salesAgrNum].svcDescription}
                <a href='#' className={`${styles['view-invoice']}`} invoicenum={successProps.salesAgreements.data[salesAgrNum].invoiceNumber} onClick={(e) => handlePopUp(e, salesAgrNum)}>{'  ' + labels.invoiceLabel}{successProps.salesAgreements.data[salesAgrNum].invoiceNumber}</a>
              </div>
              <div className={styles.amountBox}>
                <span>{labels.amtPrepaid}</span>
                <span className={styles.amount}>
                  {Globals.currencySymbol}
                  {invAmtIntPart}
                  <sup>{invAmtFractPart}</sup>
                </span>
              </div>
            </div>
          );

          }
        )}

        {(() => {
          finalAmt = finalAmtBeforeDon + donation;
          let finalAmtFormat = Number(finalAmt).toFixed(2);
          finalAmtFormatted = finalAmtFormat.toString().split('.');
        })()}
        {!oneTime && (() => { discountFormatted = discount.toString().replace('-', '').split('.'); })()}
        <div key={`finalAmtSection`} className={`${styles['serviceRow']} ${styles['total-amount']}`}>
          <div className={styles.serviceDesc}></div>
          <div className={styles.amountBox}>
            <span>{labels.totalPayment}</span>
            <span className={styles.amount}>
              {Globals.currencySymbol}{finalAmtFormatted[0]}
              <sup>{finalAmtFormatted[1] ? (finalAmtFormatted[1].length < 2 ? finalAmtFormatted[1] + '0' : finalAmtFormatted[1].substring(0, 2)) : '00'}</sup>
            </span>
            {!oneTime && <span className={`${styles['amount']} ${styles['save-amount']}`}>
              {labels.savingAmtText} {Globals.currencySymbol}{discountFormatted[0]}
              <sup>{discountFormatted[1] ? (discountFormatted[1].length < 2 ? discountFormatted[1] + '0' : discountFormatted[1].substring(0, 2)) : '00'}</sup>
            </span>}
          </div>
        </div>
        {/* Totals, donation, final payment blocks */}
        <div className={`row text-center ${styles['gfs-20']} ${styles['glh-1_2']} ${styles['gfw-2']} mb-25`}>
          <div className='col-12'>
            {labels.successNote}
          </div>
        </div>
        {oneTime &&<div className='row mb-20' >
          <div className='col-12' />
        </div>}
        <div className={styles.actions}>
          <Link to={URLS.payments} className={styles.returnBtn}>
            {labels.returnPaymentText}
          </Link>
          <button onClick={handlePrint} className={styles.printBtn}>
            {labels.printRecordText}
          </button>
        </div>
      </div>

      <InvoicesPopUp
        modalRef={modalRef}
        labels={labels}
        handleCloseModal={handleClose}
        data={popupData}
        serviceDetailsCss={styles}
      />
    </div>
  );
};

SuccessPrepay.propTypes = {
  labels: PropTypes.any,
  successProps: PropTypes.any,
  oneTime: PropTypes.bool,
};

export default SuccessPrepay;
